
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'email-bubble': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.84001 1.91992H19.2C20.256 1.91992 21.12 2.78392 21.12 3.83992V15.3599C21.12 16.4159 20.256 17.2799 19.2 17.2799H5.76001L1.92001 21.1199L1.92961 3.83992C1.92961 2.78392 2.78401 1.91992 3.84001 1.91992ZM5.76001 13.4399H17.28V11.5199H5.76001V13.4399ZM17.28 10.5599H5.76001V8.63992H17.28V10.5599ZM5.76001 7.67992H17.28V5.75992H5.76001V7.67992Z"/>'
  }
})
